/**
 * Enum for all routes in other folder.
 * @readonly
 * @enum {string}
 */
export const OTHER_PATHS = {
  IMPRINT: "/imprint",
  PRIVACY: "/privacy",
};
